<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>试卷</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData" :loading="tableForm.isLoading">
                <template #remainSeconds="item">
                    <div class="countdown" :data-time="item.row.remainSeconds">{{ formatTime(item.row.remainSeconds) }}
                    </div>
                </template>
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-if="scope.row.remainSeconds > 0" v-buttonAuth="'system:exam:participation'"
                            @click="goRecords(scope.row)">参与考试</el-button>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <el-dialog title="开始考试" :visible.sync="topicDialog.visible" custom-class="form-dialog" width="40%"
            @before-close='closeTopicDialog("edit")'>
            <div class="d-flex flex-column flex-align-center">
                <el-form :model="formInline" class="user-search" style="width: 70%;">
                    <el-form-item label="考试名称：">
                        {{ topicDialog.examItem.examName }}
                    </el-form-item>
                    <el-form-item label="考试时长：">
                        {{ topicDialog.examItem.examTimeLength }}分钟
                    </el-form-item>
                </el-form>
                <div class="exam-dialog mg-btm20">
                    <h3>考试说明</h3>
                    <div class="col-f41">1、请不要中途离开考试界面，离开或退出考试界面将自动提交试卷</div>
                    <div class="mg-tp20">2、答题时间结束，如果处于答题页面，将自动提交试卷</div>
                </div>
                <el-checkbox v-model="checked">我已阅读并同意</el-checkbox>
                <el-button type="primary" @click="startExam()" class="mg-tp20">进入考试</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import store from '../../vuex/store';
import { capitalEnglishList, fileDownload, organizationName } from "@/utils/util.js";
import courseApi from '@/api/onlineTraining/classification.js'
import { todoExamPaper, examJoin, } from '@/api/takeExam.js'
export default {
    components: {
        MyTable,
        Pagination,
        myForm,
    },
    data () {
        return {
            checked: false,
            tableForm: {
                customColumns: [
                    { label: '考试名称', prop: 'examName' },
                    { label: '剩余时间', prop: 'remainSeconds', slot: 'remainSeconds' },
                ],
                tableData: [
                ],
                isLoading: false,
            },
            topicDialog: {
                visible: false,
                examId: '',
                examItem: {},
            },
            formInline: {

            },
            time: null,
            nowTime: null
        }
    },
    mounted () {
        this.getData()
        // 组件挂载时立即更新一次当前时间
        // 每秒更新一次当前时间
    },
    beforeDestroy () {
        clearInterval(this.time)
    },
    methods: {

        async getData () {
            const res = await todoExamPaper();
            this.tableForm.tableData = res.data;
            clearInterval(this.time)
            // 每秒更新一次倒计时
            this.time = setInterval(this.updateCountdown, 1000);

            // 初始化页面时更新一次倒计时
            this.updateCountdown();
        },
        updateCountdown () {
            const countdownElements = document.querySelectorAll('.countdown');
            countdownElements.forEach(element => {
                let remainingTime = element.getAttribute('data-time');
                if (remainingTime > 0) {
                    remainingTime--;
                    const hours = Math.floor(remainingTime / 3600);
                    const minutes = Math.floor((remainingTime % 3600) / 60);
                    const seconds = remainingTime % 60;

                    element.innerHTML = `${hours}时${minutes}分${seconds}秒`;
                    element.setAttribute('data-time', remainingTime);
                } else {
                    element.innerHTML = '已过期';
                }
            });
        },
        formatTime (seconds) {
            const hours = Math.floor(seconds / 3600);
            const minutes = Math.floor((seconds % 3600) / 60);
            const remainingSeconds = seconds % 60;
            return `${hours}时${minutes}分${remainingSeconds}秒`;
        },
        goRecords (item) {
            this.topicDialog.visible = true;
            this.topicDialog.examItem = item;
        },
        async startExam () {
            if (!this.checked) {
                this.$message({
                    type: 'warning',
                    message: '请阅读并同意考试说明'
                })
                return;
            }
            const res = await examJoin({ examPaperId: this.topicDialog.examItem.examPaperId });
            this.$router.replace({ path: '/participation/underway', query: { type: '1', examId: res.data.examId } })
        },
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}

.exam-dialog {
    width: 70%;

}
</style>



// WEBPACK FOOTER //
// src/views/participation/exam.vue